import MenusNav from '@base/MenusNav/MenusNav';
import { useRouter } from 'next/router';
import { useMemo } from 'react';

const TNCMenu = ({ menuData }) => {
  const { asPath } = useRouter();
  const data = menuData;

  data.sort((current, next) => {
    if (current.order === null || next.order === 0) return 1;
    if (current.order === 0 || next.order === null) return -1;
    if (current.order === 0 && next.order === 0) return 0;
    return current.order - next.order;
  });

  const menus = useMemo(() => {
    return data?.map((menu) => {
      return {
        label: menu.label,
        url: {
          href: menu.url === 'terms' ? '/terms' : `/terms/${menu.url}`,
          as: menu.url === 'terms' ? '/terms' : `/terms/${menu.url}`
        }
      };
    });
  }, [data]);

  if (!menuData) return null;

  return <MenusNav data={menus || []} currentHref={asPath} />;
};

export default TNCMenu;
